import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ErrorAlert } from "global/alert/Alert";
import { filterTableDataAPI, getAPI } from "services/CRUDServices"
import { addEditUrls, filterUrls } from "services/api.enums"

export const filterCreditSettlement: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "creditsettlement",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      filterUrls.creditSettlement,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    );

    // console.log("data.data", body)
    let url = addEditUrls.fetchSharePercentageFromCredit
    let ids = data.data.payload.content.map((item: any) => {
      return { ...item, driverId: item.id, url: `${url}${item.id}` }
    })

    const fetchJson = async (item: any) =>
      await getAPI(item.url, true)
        .then((res: any) => {
          return { ...item, ...res.data.payload }
        })
        .catch((error) => {
          ErrorAlert(error?.response?.data?.errors?.message)
        })

    let content: any = []
    content = await Promise.all(ids.map((item: any) => fetchJson(item))).then(
      (values) => values
    )
    console.log(content)
    const arr1=content.filter(Boolean)
    data.data.payload.content = arr1;

    return data.data
  }
);

const initialState: any = {
  settlementData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
  
};

const CreditSettlementSlice = createSlice({
  initialState: initialState,
  name: "creditsettlement",
  reducers: {
    clearCreditSettlement: (state) => {
      state.settlementData = [];
    },
    setFilterCreditSettlement: (state, action) => {
      state.filter = action.payload;
    },

  },
  extraReducers: {
    [filterCreditSettlement.fulfilled as any]: (state, action) => {
      state.settlementData = action.payload;
      state.fetchPost = false;
    },
    [filterCreditSettlement.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterCreditSettlement.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterCreditSettlement, clearCreditSettlement } = CreditSettlementSlice.actions;

export default CreditSettlementSlice.reducer;
